import { endPoints } from 'api/endpoints';
import axios from 'api/request';

/**
 * Fetches landing zone details if all required values are present
 * @param {Object} params - Parameters for landing zone API
 * @param {string} params.sector - Sector value
 * @param {string} params.department - Department value
 * @param {string} params.environment - Environment value
 * @param {string} params.appRegion - Region value (applicationRegion)
 * @returns {Promise<Object|null>} Landing zone details or null
 */
export const fetchLandingZoneDetails = async ({ appProfile, sector, department, environment, appRegion }) => {
    if (!appProfile || !sector || !department || !environment || !appRegion) {
        return null;
    }
    try {
        const payload = {
            applicationServiceName: appProfile,
            sector,
            environment,
            department,
            applicationRegion: appRegion,
        };
        const response = await axios.post(endPoints.aws.Ec2.awsLandingZone, payload);
        return response?.data || null;
    } catch (error) {
        return null;
    }
};
export default {};
